import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';

import useStyles from "./styles";
import { CheckboxField, InputBaseField, SelectField } from '../../../../components/InputField/InputField';
import { PostDataAPI } from '../../../../Services/APIService';
import { Label, DraggableComponent } from '../../../../components/UiElements/UiElements';
import {
    handleNumberKeyPress, formateMdnNumber, handleNegativeNumberWithDecimal
} from '../../../../components/Common/Extensions';
import DialogLoader from './../../../../components/Loader/DialogLoader';
import { withSnackbar } from "../../../../components/Message/Alert";
import { GetUserInfo } from "../../../../Services/GetUserInfo";

function DataBoost({ dialogOpenClose, handleClose, handleSuccessClose, mdnNumber, accountNumber, isPrepaid, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [loading, setLoading] = useState(false);
    const [errorMessages, setErrorMessages] = useState({
        errorPhoneLength: false
    });
    let user_info = JSON.parse(GetUserInfo());
    const [userInfo, setUserInfo] = useState(user_info.user);
    const [wirelessPlans, setWirelessPlans] = useState([]);

    const [state, setState] = useState({ planId: '' });

    const handleSelectChange = (name, value) => {
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const handleChangeNumber = (e) => {
        const { name, maxLength, value } = e.target;
        if (/^\d*$/.test(value) && value.length <= 10) {
            setState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    };

    const handleCashChange = (e) => {
        ///^-?[\d]*$/
        const { name, maxLength, value } = e.target;
        if (/^-?[\d]*$/.test(value) && value.length <= 10) {
            setState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const isDeafultDateTime = (_value) => {
        const dateObject = new Date(_value);
        const defaultDate = new Date(0); // This creates the default date "1/1/1970 00:00:00 UTC"
        // Compare the given date to the default reference date
        var isDefaultDate = dateObject.getFullYear() < defaultDate.getFullYear()
        return isDefaultDate;

    }

    const getLineBalanceInfo = () => {
        var obj = {
            mDN: mdnNumber
        };
        setLoading(true);
        PostDataAPI("telispire/GetLineBalance", obj).then((result) => {
            setLoading(false);
            if (result.success && result.data != null) {
                result.data.endDate = isDeafultDateTime(result.data.endDate) ? '' : result.data.endDate
                result.data.unlimitedVoiceEndDate = isDeafultDateTime(result.data.unlimitedVoiceEndDate) ? '' : result.data.unlimitedVoiceEndDate
                result.data.unlimitedDataEndDate = isDeafultDateTime(result.data.unlimitedDataEndDate) ? '' : result.data.unlimitedDataEndDate
                result.data.unlimitedSMSEndDate = isDeafultDateTime(result.data.unlimitedSMSEndDate) ? '' : result.data.unlimitedSMSEndDate
                result.data.planId = result.data.planId + ''
                setState(result.data);
            }
            else {

            }

        })
    }

    const getWireLessPlans = () => {
        debugger
        var params = {
            code: "get_postpaid_wireless_plans",
            parameters: [accountNumber + "", userInfo.hidePlanPriceFlag + ""]
        };
        if (isPrepaid) {
            params = {
                code: "get_prepaid_wireless_plans",
                parameters: [accountNumber + "", userInfo.hidePlanPriceFlag + ""]
            };
        }

        PostDataAPI("ddl/loadItems", params).then((result) => {
            if (result.success && result.data != null) {
                result.data.unshift({ t2: 'Please Select Plan', t1: 0 });
                setWirelessPlans(result.data.map(t => { return { label: t.t2, value: t.t1 } }));
            }
        })
    }


    const updateBucket = () => {
        var params = {
            mDN: mdnNumber,
            accountNumber: accountNumber,
            planId: state.planId ? parseInt(state.planId) : null,
            minutes: state.minutes ? parseInt(state.minutes) : null,
            smsMessages: state.smsMessages ? parseInt(state.smsMessages) : null,
            kilobytes: state.kilobytes ? parseInt(state.kilobytes) : null,
            cashValue: state.cashValue ? parseFloat(state.cashValue) : null,
        }
        setLoading(true);
        PostDataAPI("telispire/lineBucketUpdate", params, true).then((result) => {
            setLoading(false);
            if (result.success && result.data != null) {
                //Plan balance updated successfully
                handleSuccessClose("Bucket updated successfully")
            } else {
                showMessage("Error", result.message, "error", 3000);
            }
        })
    }

    useEffect(() => {
        getLineBalanceInfo();
        getWireLessPlans();
    }, [])

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            disableEscapeKeyDown
            open={dialogOpenClose}
            PaperComponent={!window.isIpadView ? DraggableComponent : undefined}
            maxWidth="lg"
            {...props} >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Bucket Update - {formateMdnNumber(mdnNumber)}</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={500}>
                        <div className={classes.content}>
                            {loading ? <DialogLoader></DialogLoader> : ''}

                            <Grid row style={{ paddingTop: '10px' }}>

                                <Grid container direction="column">

                                    <Grid xl={12} md={12} sm={12} lg={12} className={classes.paddingLeftRight}>
                                        <Label title="End date" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="endDate"
                                                name="endDate"
                                                type="date"
                                                value={state.endDate?.split('T')[0]}
                                                placeholder="End Date"
                                                onChange={handleChange}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                                <Grid container direction="column">

                                    <Grid xl={12} md={12} sm={12} lg={12} className={classes.paddingLeftRight}>
                                        <Label title="Plan" size={12} />

                                        <SelectField
                                            id="planId"
                                            name="planId"
                                            options={wirelessPlans}
                                            onChange={handleSelectChange}
                                            value={state?.planId}
                                        />

                                    </Grid>
                                </Grid>

                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Minutes Individual" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="minutes"
                                                name="minutes"
                                                type="text"
                                                value={state.minutes}
                                                placeholder="Minutes"
                                                MaxLength='5'
                                                onChange={handleChange}
                                                onKeyPress={(e) => handleNumberKeyPress(e)}
                                            />
                                        </Grid>

                                    </Grid>

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Minutes Shared" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="sharedMinutes"
                                                name="sharedMinutes"
                                                type="text"
                                                value={state.sharedMinutes}
                                                placeholder="Minutes Shared"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="SMS Messages Individual" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="smsMessages"
                                                name="smsMessages"
                                                type="text"
                                                value={state.smsMessages}
                                                placeholder="SMS Messages"
                                                MaxLength='5'
                                                onChange={handleChange}
                                                onKeyPress={(e) => handleNumberKeyPress(e)}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="SMS Messages Shared" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="sharedSMS"
                                                name="sharedSMS"
                                                type="text"
                                                value={state.sharedSMS}
                                                placeholder="SMS Shared"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Kilobytes Individual" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="kilobytes"
                                                name="kilobytes"
                                                type="text"
                                                value={state.kilobytes}
                                                placeholder="Kilobytes"
                                                MaxLength='10'
                                                onChange={handleChange}
                                                onKeyPress={(e) => handleNumberKeyPress(e)}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Kilobytes Shared" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="sharedKilobytes"
                                                name="sharedKilobytes"
                                                type="text"
                                                value={state.sharedKilobytes}
                                                placeholder="KiloBytes Shared"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Cash Individual" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="cashValue"
                                                name="cashValue"
                                                type="text"
                                                placeholder="Cash"
                                                value={state.cashValue}
                                                MaxLength='5'
                                                onChange={handleChange}
                                                onKeyPress={(e) => handleNegativeNumberWithDecimal(e)}

                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Cash Shared" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="sharedCashValue"
                                                name="sharedCashValue"
                                                type="text"
                                                value={state.sharedCashValue}
                                                placeholder="Cash Shared"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>


                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Unlimited Voice" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <CheckboxField
                                                color="primary"
                                                name="hasUnlimitedVoice"
                                                checked={state.hasUnlimitedVoice ? true : false}
                                                label="Unlimited Voice"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="End Date" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="unlimitedVoiceEndDate"
                                                name="unlimitedVoiceEndDate"
                                                type="date"
                                                value={state.unlimitedVoiceEndDate?.split('T')[0]}
                                                placeholder="UnlimitedVoiceEndDate"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Unlimited SMS" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <CheckboxField
                                                color="primary"
                                                name="hasUnlimitedSMS"
                                                checked={state.hasUnlimitedSMS ? true : false}
                                                label="Unlimited SMS"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="End Date" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="unlimitedSMSEndDate"
                                                name="unlimitedSMSEndDate"
                                                type="date"
                                                value={state.unlimitedSMSEndDate?.split('T')[0]}
                                                placeholder="UnlimitedSMSEndDate"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>


                                <Grid container direction="flex">

                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="Unlimited Data" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <CheckboxField
                                                color="primary"
                                                name="hasUnlimitedData"
                                                checked={state.hasUnlimitedData ? true : false}
                                                label="Unlimited Data"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                    <Grid xl={6} md={6} sm={6} lg={6} className={classes.paddingLeftRight}>
                                        <Label title="End Date" size={12} />
                                        <Grid xl={12} md={12} sm={12} lg={12}>
                                            <InputBaseField
                                                id="unlimitedDataEndDate"
                                                name="unlimitedDataEndDate"
                                                type="date"
                                                value={state.unlimitedDataEndDate?.split('T')[0]}
                                                placeholder="unlimitedDataEndDate"
                                                IsDisabled={true}
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </div>

                    </Scrollbars>
                    <div className={classes.footer}>

                        <div className={classes.footerRight}>

                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                            <Button className={classes.changeBtn} onClick={updateBucket}>Update</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog >
    )
}

export default withSnackbar(DataBoost);